import { EventEmitter, Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Constants } from '../config/constant';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private socket$: WebSocketSubject<string>;
  dataChanged = new EventEmitter<string>();
  websocketClosed = new EventEmitter<boolean>();

  constructor(private _const: Constants) {}

  connect(): void {
    this.socket$ = webSocket({url: `${this._const.API.replace('https', 'wss')}/clientonboarding/status`, deserializer: ({ data }) => data });
    this.socket$.subscribe(
      (message) =>
      {
        this.dataChanged.emit(message);
      },
      (error) => console.error('WebSocket error:', error),
      () => this.websocketClosed.emit( true )
    );
  }

  send(message: any): void {
    if (this.socket$ && !this.socket$.closed) {
      this.socket$.next(message);
    } else {
      console.error('WebSocket is not open');
    }
  }

  disconnect(): void {
    if (this.socket$ && !this.socket$.closed) {
      this.socket$.complete();
    }
  }
}
